(ns frontend.view.metabase-dashboard.events
  (:require
   [frontend.controller.websocket.event :as ws]
   [frontend.view.metabase-dashboard.sub :as sub]
   [re-frame.core :as rf]))

(rf/reg-event-fx
 ::get-dashboard-url-ok
 (fn [{db :db} [_ report-id response]]
   {:db (-> db
            (assoc-in [::sub/metabase-configs report-id]
                      (:body response)))}))


(rf/reg-event-fx
 ::get-dashboard-url-failed
 (fn [{db :db} [_ response]]
   (js/console.log "Unimplemented get-dashboard-url-failed " response)))

(rf/reg-event-fx
 ::get-dashboard-url
 (fn [{:keys [db]} [_ report-id pipeline-id]]
   {::ws/send {:id         :metabase-dashboard/get-dashboard-url
               :body       {:report-id   report-id
                            :pipeline-id pipeline-id}
               :on-success [::get-dashboard-url-ok report-id]
               :on-error   [::get-dashboard-url-failed report-id]}}))

(rf/reg-event-fx
 ::select-pipeline-id
 (fn [{:keys [db]} [_ report-id pipeline-id]]
   {:db (-> db
            (assoc-in [::sub/selected-pipeline-id] pipeline-id))
    :fx [[:dispatch [::get-dashboard-url report-id pipeline-id]]]}))

(rf/reg-event-fx
 ::init
 (fn [{:keys [db]} [_ report-id]]
   (let [first-pipeline-id (->> (sub/active-pipelines)
                                (map :db/id)
                                (first))]
     {:fx [[:dispatch [::select-pipeline-id report-id first-pipeline-id]]]})))
